module.exports = __webpack_public_path__ + "img/Card_heart_A.058d353d.svg";